<template>
  <div class="modal__wrap--bg cmp-modal" :class="{'is-active': showModal}" id="attendance-modal-template">
    <div class="modal-wrap-container modal-wd1020">
      <div class="modal-header">
        <div class="title">출석 확인</div>
        <!-- {{rollbook.title}} -->
      </div>
      <div class="modal-body-container">
        <div class="table-wrap no-line-mg scroll-table">
          <table class="table-list">
            <caption>수강 강좌 목록</caption>
            <colgroup class="pc-cell">
              <col style="width:33%">
              <col style="width:33%">
              <col>
            </colgroup>
            <colgroup class="mo-cell">
              <col style="width:150px">
              <col style="width:450px">
              <col style="width:150px">
            </colgroup>
            <thead>
              <tr>
                <th scope="col">날짜</th>
                <th scope="col">시간</th>
                <th scope="col">출석</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(book, index) in rollbook" :key="index">
                <td class="text-c">{{dateFormat(book.date)}}</td>
                <td class="text-c">{{timeFormat(book.startTime)}}-{{timeFormat(book.endTime)}}</td>
                <td class="text-c" :class="{'color-hilight': book.roll === '불참'}">{{book.roll}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-md button-wid150  close-modal" @click="close">
          닫기
        </button>
      </div>
      <button type="button" class="btn btn-close only-icon close-modal" aria-label="닫기" @click="close" title="닫기">
        <i class="ico ico-x-bl"></i>
      </button>
    </div>
  </div>
</template>
<script>
  import axios from 'axios';

  export default {
    name: 'attendance-modal-template',
    data() {
      return {
        rollbook: [],
        showModal: false,
      };
    },
    computed: {
      rollBookList() {
        const rollList = this.rollbook;
        rollList.sort((a, b) => {
          if (a.orderValue > b.orderValue) {
            return 1;
          }
          if (a.orderValue < b.orderValue) {
            return -1;
          }
          return 0;
        });
        return rollList;
      },
    },
    methods: {
      setButtons() {
        $('.attendance-btn').on('click', { thisVal: this }, (event) => {
          const varEvent = event;
          const IECheck = this.globalGetInternetExplorerVersion();
          let courseId = '';
          if (IECheck <= 10) {
            courseId = varEvent.currentTarget.getAttribute('data-courseId');
          } else {
            courseId = varEvent.target.dataset.courseid;
          }
          varEvent.data.thisVal.courseid = courseId;
          this.getRollbook(courseId);
          $('body').addClass('modal-open');
          this.showModal = true;
        });
      },
      getRollbook(courseid) {
        axios.get(`/api/courses/${courseid}/rollbook`).then((response) => {
          const booklist = [];
          const rollBookList = response.data.rollBookList || [];
          for (let i = 0; i < rollBookList.length; i += 1) {
            booklist.push({
              date: rollBookList[i].date,
              startTime: rollBookList[i].startTime,
              endTime: rollBookList[i].endTime,
              roll: rollBookList[i].roll,
              orderValue: `${rollBookList[i].date}${rollBookList[i].startTime}`,
            });
          }
          this.rollbook = booklist;
        }).catch((error) => {
          console.log(error.data);
        });
      },
      close() {
        this.showModal = false;
        this.rollbook = [];
        document.getElementsByTagName('body')[0].classList.remove('modal-open');
      },
      timeFormat(time) {
        const hh = time.substr(0, 2);
        const mm = time.substr(2, 2);
        return `${hh}:${mm}`;
      },
      dateFormat(date) {
        const year = date.substr(0, 2);
        const month = date.substr(2, 2);
        const day = date.substr(4);
        return `${year}.${month}.${day}`;
      },
    },
    mounted() {
      this.setButtons();
    },
  };
</script>



// WEBPACK FOOTER //
// AttendanceButton.vue?2f3f9cbc